<template>
  <div class="user__card flex items-center">
    <a
      :href="`/${PROFILE_PATH}/${user.username}`"
      class="flex items-center py-2 flex-1"
      rel="nofollow"
      @click="$analyticsEvent('User', 'User_Engagement', 'action_profile_click')"
    >
      <OAvatar rounded class="h-10 w-10 object-cover" :src="userAvatarUrl" :alt="user.name"></OAvatar>
      <div class="ml-4 hover:link-primary text-base">{{ user.username }}</div>
    </a>
    <div v-if="userId !== user._id" class="flex justify-between flex-wrap text-13 items-center">
      <OButton
        :variant="followedByMe ? 'outline' : 'solid'"
        :color-scheme="followedByMe ? 'gray' : 'blue'"
        size="xs"
        style="min-width: 120px; padding: 0 16px; height: 32px; border-radius: 32px"
        class="rounded-full"
        @click="handleFollowUser"
      >
        {{ followedByMe ? $t('profile.following') : $t('profile.follow') }}
      </OButton>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent, ref, useContext, useRoute } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import { OAvatar, OButton } from '@/modules/common/components/ui';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { eventBus } from '~/modules/common/utils/eventBus';
import { useModal, useToast } from '~/composables/useModal';
import { useAuth } from '~/modules/auth/state/useAuth';
import { PROFILE_PATH } from '~/constants/config';

export default defineComponent({
  props: ['user'],
  components: {
    OAvatar,
    OButton,
  },
  setup(props) {
    const { $service, i18n } = useContext();
    const { isMobile } = useDevice();
    const { toastDanger } = useToast();
    const { openLoginModal } = useModal();
    const route = useRoute();
    const username = route.value.params.username;
    const { user, isLoggedIn } = useAuth();
    const userId = isLoggedIn.value ? user.value._id : 'anonym';
    const isMe = user.value?.username === username;
    const userAvatarUrl = computed(() => getImageUrl(props.user.avatar, { standard: true }));
    const handleSendMessage = () => {
      if (!isLoggedIn.value) {
        openLoginModal();
        return;
      }
      eventBus.emit('open-conversation', { user: props.user });
    };
    const followedByMe = ref(isMe && !props.user.hasOwnProperty('followStatus') ? true : props.user.followStatus);
    const handleFollowUser = async () => {
      if (!isLoggedIn.value) {
        openLoginModal();
        return;
      }
      try {
        if (followedByMe.value) {
          await $service.user.unFollowUser(props.user._id);
        } else {
          await $service.user.followUser(props.user._id);
        }
        followedByMe.value = !followedByMe.value;
      } catch (error) {
        toastDanger(i18n.t('profile-edit.dialog-text-10'));
      }
    };

    return {
      userId,
      isMobile,
      followedByMe,
      userAvatarUrl,
      handleFollowUser,
      handleSendMessage,
      PROFILE_PATH,
    };
  },
});
</script>
